const HEADER_SELECTOR: string = "[data-header]";
const DROPDOWN_SELECTOR: string = "[data-header-dropdown]";
const DROPDOWN_BUTTON_SELECTOR: string = "[data-header-dropdown-button]";
const FORM_SELECTOR: string = "#searchbar-form";
const SEARCH_SELECTOR: string = "#searchbar-input";
const INFO_SELECTOR: string = ".searchbar__button__info";

export class HeaderUI {

  public allowFadeOut: boolean = false;
  private minLength: number = 3;

  public constructor(private $base: HTMLElement) {
  }

  public onScroll(callback) {
    window.addEventListener("scroll", () => {
      callback();
    });
  }

  public getScrollTop() : number {
    return document.documentElement.scrollTop;
  }

  public checkSearchLenght(callback) {
    setTimeout(() => {
      this.$base.querySelector(FORM_SELECTOR).addEventListener('submit', () => {
        const input = this.$base.querySelector(SEARCH_SELECTOR) as HTMLInputElement;
        if (input.value.toString().length < this.minLength) {
          this.$base.querySelector(INFO_SELECTOR).classList.remove('is-hidden');
          return false;
        }
      })
    }, 1000);
  }

  public removeStickyClass() {
    if (this.allowFadeOut) {
      this.$base.classList.add("fade-out");
      this.$base.classList.remove("is-fixed");
      window.setTimeout(() => {
        document.body.classList.remove("header--fixed");
        this.$base.classList.remove('fade-out');
        this.allowFadeOut = false;
      }, 500);
    }
  }

  public clickDropdownLink() {
    this.$base.querySelector(".dropdown__placeholder").addEventListener('click', (e) => {
      this.$base.querySelector(DROPDOWN_BUTTON_SELECTOR).classList.toggle('dropdown-active');
      this.$base.querySelector(DROPDOWN_SELECTOR).classList.toggle('dropdown-active');
      e.preventDefault();
      return false;
    });
  }

  public clickDropdownArrow() {
    this.$base.querySelector(DROPDOWN_BUTTON_SELECTOR).addEventListener('click', () => {
      this.$base.querySelector(DROPDOWN_BUTTON_SELECTOR).classList.toggle('dropdown-active');
      this.$base.querySelector(DROPDOWN_SELECTOR).classList.toggle('dropdown-active');
    });
  }

  public addStickyClass() {
    document.body.classList.add("header--fixed");
    this.$base.classList.remove("fade-out");
    this.$base.classList.add("is-fixed");
  }
}

export function createHeaderUI() {
  const $base = document.querySelectorAll(HEADER_SELECTOR);
  let uiInstances: HeaderUI[] = [];

  for (let index = 0; index < $base.length; index++) {
    const element = $base[index] as HTMLElement;
    uiInstances.push(new HeaderUI(element));
  }
  return uiInstances;
}
